import React, { useRef } from "react";
import PageHeader from "./PageHeader";
import EnrolmentSection from "./EnrolmentSection";
import "../styles/about.css";

const About = () => {
  const iframeRef = useRef(null);

  return (
    <>
      {/* Top banner for the subpage */}
      <PageHeader
        title="About Us"
        image="/media/gallery-7.jpg"
        height="200px"
      />

      {/* Section 1: THE AVENUE SCHOOL / Our School */}
      <section className="about-wrap">
        <div className="about-card">
          <header className="about-card__header">
            <p className="about-eyebrow">THE AVENUE SCHOOL</p>
            <h2 className="about-title">Our School</h2>
            <p className="about-body">
              The Avenue School is a Senior Secondary Specialist School dedicated to supporting young
              people who have disengaged from traditional education. We offer a flexible, inclusive
              learning environment tailored to individual needs, with a strong focus on wellbeing and
              personal growth.<br/><br/>
              Our small cohort model fosters connection, safety, and confidence, allowing students to
              thrive academically and socially. Rooted in trauma-informed practice and guided by empathy,
              respect, and empowerment, we help students rediscover their love for learning and prepare
              for meaningful futures. Whether pursuing trades, nursing, or creative pathways, every student
              is supported to reach their goals in a nurturing, student-led setting.
            </p>
          </header>

          <div className="about-duo">
            <img
              className="about-duo__img"
              src="/media/gallery-1.jpg"
              alt="Students and staff learning together"
            />
            <img
              className="about-duo__img about-duo__img--tall"
              src="/media/gallery-2.jpg"
              alt="Supportive classroom environment"
            />
          </div>
        </div>
      </section>

      {/* Section 2: Philosophy & Values */}
      <section className="about-split">
        <div className="about-split__col">
          <h3 className="about-subtitle">Our Philosophy</h3>
          <p className="about-body">
            We believe every student deserves equal opportunity, regardless of life circumstances. Our
            approach respects individuality, fosters belonging, and encourages intrinsic motivation. Learning
            is personalised, interest-driven, and designed to build confidence, resilience, and success.
          </p>
        </div>
        <div className="about-split__col">
          <h3 className="about-subtitle">Our Values</h3>
          <p className="about-body">
            We are inclusive, kind, and courageous. We celebrate diversity, act with honesty, and nurture
            empathy. Respect for self, others, and the environment is central to our community. We create a
            safe space where students feel heard, supported, and empowered.
          </p>
        </div>
      </section>

      {/* Section 3: Why we exist + YouTube video (max width 850px) */}
      <section className="about-why">
        <h3 className="about-subtitle about-subtitle--center">
          Why We Exist: Supporting Students Who Need a Different Kind of School Environment
        </h3>
        <p className="about-body about-body--center">
          The Avenue School was born from the Mountain District Women’s Co-op’s commitment to supporting
          vulnerable youth. Building on the success of the Cottage Program, we provide a bespoke education
          model for students with high anxiety and school refusal. Our mission is to remove barriers to
          learning by creating a calm, adaptive, and engaging environment. We exist to help students reconnect
          with education, build trust, and develop the skills and confidence needed for a fulfilling future.
        </p>

        {/* Responsive 16:9 YouTube, capped at 850px */}
        <div className="about-video">
          <div className="ratio-16x9">
            <iframe
              ref={iframeRef}
              src="https://www.youtube.com/embed/UDyaAKTPti8?controls=1&rel=0&playsinline=1"
              title="Inside Our School"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <EnrolmentSection />
    </>
  );
};

export default About;